// removed by extract-text-webpack-plugin
module.exports = {"percentageGratuiti":"app-pages-Library-SalesType-SalesTypeDetail-SalesTypeGratuity-__SalesTypeGratuity___gawWY","marginBotGratuiti":"app-pages-Library-SalesType-SalesTypeDetail-SalesTypeGratuity-__SalesTypeGratuity___nH0Ly","borderGratuiti":"app-pages-Library-SalesType-SalesTypeDetail-SalesTypeGratuity-__SalesTypeGratuity___6Iiuq"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/SalesType/SalesTypeDetail/SalesTypeGratuity/SalesTypeGratuity.css
// module id = 2459
// module chunks = 0